import { render } from "./Charter.vue?vue&type=template&id=0efb9d38&scoped=true"
import script from "./Charter.vue?vue&type=script&lang=js"
export * from "./Charter.vue?vue&type=script&lang=js"

import "./Charter.vue?vue&type=style&index=0&id=0efb9d38&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0efb9d38"]])

export default __exports__